import { render, staticRenderFns } from "./PaginaIndisponivel.vue?vue&type=template&id=ca02b71e&scoped=true"
import script from "./PaginaIndisponivel.vue?vue&type=script&lang=js"
export * from "./PaginaIndisponivel.vue?vue&type=script&lang=js"
import style0 from "./PaginaIndisponivel.vue?vue&type=style&index=0&id=ca02b71e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca02b71e",
  null
  
)

export default component.exports